<template>
  <div :class="{ 'd-none': $vuetify.breakpoint.xs }" class="board__persons">
    <div class="board__person-wrapper--line" v-if="host">
      <v-icon class="grey lighten-3 grey--text text--lighten-1" left
        >mdi-account-tie</v-icon
      >
      <div class="board__person">
        <h5 class="grey--text">
          {{ $t('board.host') }}
        </h5>
        <p class="mb-0 caption">{{ host }}</p>
      </div>
    </div>
    <div class="board__person-wrapper--line" v-if="visitor">
      <v-icon class="grey lighten-3 grey--text text--lighten-1" left
        >mdi-account</v-icon
      >
      <div class="board__person">
        <h5 class="grey--text">
          {{ $t('board.visitor') }}
        </h5>
        <p class="mb-0 caption">{{ visitor }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardLinePersons',

  props: {
    host: {
      type: String,
    },
    visitor: {
      type: String,
    },
  },
}
</script>
